import styled from "styled-components";
import { HeadLine1 } from "../../components/typography/styled";



export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px 30px 50px 20px;
  position: relative;

  @media (max-width: 768px) {
    padding: 10px 15px 30px 15px;
  }
`

export const TitleBig = styled(HeadLine1)`
  color:${({theme}) => theme.palette[850]};
  /* margin-top: 20px; */
  margin-bottom: 20px;
`
export const NavWrapper = styled.div`
  border-bottom: ${({theme}) => `1px solid ${theme.grey[350]}`};
  position: relative;
  display: flex;
  margin-top:40px;
  margin-bottom:20px;
  &>div{
    position: absolute;
    bottom:-1px;
    left:0px;
  }

  @media (max-width: 768px) {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin-top: 20px;
    margin-bottom: 15px;
    width: 100%;
    padding-bottom: 8px;

    &>div {
      position: relative;
      width: max-content;
      min-width: 100%;
    }

    ::-webkit-scrollbar {
      height: 2px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({theme}) => theme.primary[400]};
      border-radius: 1px;
    }
    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }
`
